import { Button } from "primereact/button";
import {observer} from 'mobx-react-lite'

const NumericPagination = ({ query, onPageChange }) => {
    const { page_number, page_count } = query;

    if (page_count <= 1) return null;

    return (
        <div className="pagination-wrapper">
            <div className="pagination-scroll">
                {Array.from({ length: page_count }, (_, i) => {
                    const page = i + 1;
                    const isActive = page === page_number;

                    return (
                        <Button
                            key={page}
                            label={String(page)}
                            size="small"
                            rounded
                            outlined={!isActive}
                            severity={isActive ? "primary" : "secondary"}
                            className="pagination-btn"
                            onClick={() => onPageChange(page)}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default observer(NumericPagination)
